import { put, call, takeLatest } from 'redux-saga/effects'

import * as AccountSettingsTypes from 'Redux/Types/AccountSettingsTypes'
import * as AccountSettingsActions from 'Redux/Actions/AccountSettingsActions'
import { updateSendForHumanReviewSettingApi } from 'Service/Api'

function* updateSendForHumanReviewSettingFn({ payload }) {
  try {
    const { data } = yield call(updateSendForHumanReviewSettingApi, payload)
    yield put(AccountSettingsActions.updateSendForHumanReviewSettingSucceed(data))
  } catch (err) {
    yield put(AccountSettingsActions.updateSendForHumanReviewSettingFailed(err))
  }
}

export default function* AccountSettingsSaga() {
  yield takeLatest(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    AccountSettingsTypes.UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING,
    updateSendForHumanReviewSettingFn,
  )
}
